module.exports = __webpack_public_path__ + "static/media/Rockstar.e3c79fac.svg";